/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import TransparentBlogCard from "examples/Cards/BlogCards/TransparentBlogCard";

// Images
import post1 from "assets/images/1.png";
import post2 from "assets/images/2.png";
import post3 from "assets/images/3.png";
import post4 from "assets/images/4.3.png";

function Services() {
  return (
    <MKBox component="section" py={6}>
      <Container>
        <Grid container item xs={12} lg={6}>
          <MKTypography variant="h3" mb={8}>
            Conocé la familia Hyundai
          </MKTypography>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} lg={3}>
            <TransparentBlogCard
              image={post1}
              title="Quienes somos"
              description="Somos Seoul, una empresa dinámica que evoluciona a las necesidades del mercado ..."
              action={{
                type: "internal",
                route: "/about-us",
                color: "info",
                label: "Más información",
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <TransparentBlogCard
              image={post2}
              title="Servicio de venta"
              description="Somos una empresa joven, e innovadora, donde priorizamos la satisfacción del cliente ..."
              action={{
                type: "internal",
                route: "/sale",
                color: "info",
                label: "Más información",
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <TransparentBlogCard
              image={post3}
              title="Servicio de postventa"
              description="Ofrecemos el mejor servicio ya que contamos con uno de los talleres más destacados dentro de la red ..."
              action={{
                type: "internal",
                route: "/post-sale",
                color: "info",
                label: "Más información",
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <TransparentBlogCard
              image={post4}
              title="Nuestros modelos"
              description="Conoce todos los últimos modelos que tenemos disponibles para vos en nuestro concesionario."
              action={{
                type: "internal",
                route: "#products",
                color: "info",
                label: "Más información",
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Services;
